import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  ForgotPasswod,
  setPassword,
} from '../interfaces/forgot-pass.interface';

@Injectable()
export class ForgotPassService {
  constructor(private http: HttpClient) {}

  forgotRequest(reg: ForgotPasswod): Observable<any> {
    const url = environment.baseUrl + environment.wso2amEndPoint +
      environment.identityServerName +
      environment.wso2amApiVersion +
      '/public/v1/auth/recoverPassword';
    return this.http.post(url, reg);
  }

  setPassword(reg: setPassword): Observable<any> {
    const url = environment.baseUrl + environment.wso2amEndPoint +
      environment.identityServerName +
      environment.wso2amApiVersion +
      '/public/v1/auth/setPassword';
    return this.http.post(url, reg);
  }

  getCaptchaImageAndKey(): Observable<any> {
    const url = environment.baseUrl + environment.wso2amEndPoint +
      environment.identityServerName +
      environment.wso2amApiVersion +
      '/public/v1/auth/captcha';
    return this.http.get(url);
  }
}
